import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { AccountingChangeOptionsModel } from './typings/admin-dashboard.accounting-change.options';
import { ApiService }                   from '../api/api.service';
import { ChangeAccountingComponent }    from './admin-dashboard.change-accounting.component';
import { CodeTypeModel }                from '../core/models/code-type';
import { WsImportTableModel }           from './typings/admin-dashboard.ws-import-table';
import { WsToWsImportComponent }        from './admin-dashboard.ws-to-ws-import.component';

@Injectable({
  providedIn: 'root'
})
export class AdminDashboardService {

  constructor (
    private apiService  : ApiService,
    private modalService: NgbModal,
  ) {}

  changeAccountingIntegration ( company : any ) : Promise<void> {
    const modalRef = this.modalService.open(ChangeAccountingComponent, {
        windowClass: 'lg-modal'
      });

    modalRef.componentInstance.company = company;

    return modalRef.result;
  }

  confirmAccountingChange ( options : AccountingChangeOptionsModel ) : Promise<any> {
    return this.apiService.post('/accounting_change/action', options);
  }

  getAccountingChangeInvoiceOptions () : Array<CodeTypeModel> {
    return [
      {
        code          : 'A',
        description   : 'Sync ALL Invoices',
        language_label: 'DASHBOARD_SPACE.ADMIN_DASHBOARD.ACCOUNTING_CHANGE.SYNC_ALL_INVOICES'
      },
      {
        code          : 'B',
        description   : 'Sync Invoices ON/AFTER date',
        language_label: 'DASHBOARD_SPACE.ADMIN_DASHBOARD.ACCOUNTING_CHANGE.SYNC_INVOICES_ON_AFTER_DATE'
      },{
        code          : 'C',
        description   : 'Sync Invoices from TODAY',
        language_label: 'DASHBOARD_SPACE.ADMIN_DASHBOARD.ACCOUNTING_CHANGE.SYNC_INVOICES_FROM_TODAY'
      }
    ];
  }

  getAccountingChangePackages () : Array<CodeTypeModel> {
    return [
      {
        code          : 'myob',
        description   : 'Myob',
        language_label: 'COMPANY_SPACE.INTEGRATIONS.MYOB.MYOB_LABEL'
      },
      {
        code          : 'qbo',
        description   : 'QuickBooks',
        language_label: 'COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS'
      },
      {
        code          : 'xero',
        description   : 'Xero',
        language_label: 'COMPANY_SPACE.INTEGRATIONS.XERO.XERO'
      }
    ];
  }

  getImportTables () : Array<WsImportTableModel> {
    return [
      {
        child         : 'vehicles',
        description   : 'customers',
        language_label: 'GROUP_RIGHT_TYPES.CUSTOMERS',
        name          : 'customers',
        parent        : '',
        status        : false
      },
      {
        child         : 'invoices',
        description   : 'vehicles',
        language_label: 'GROUP_RIGHT_TYPES.VEHICLES',
        name          : 'vehicles',
        parent        : 'customers',
        status        : false
      },
      {
        child         : '',
        description   : 'vendors',
        language_label: 'GROUP_RIGHT_TYPES.VENDORS',
        name          : 'vendors',
        parent        : '',
        status        : false
      },
      {
        child         : '',
        description   : 'products',
        language_label: 'GROUP_RIGHT_TYPES.PRODUCTS',
        name          : 'products',
        parent        : '',
        status        : false
      },
      {
        child         : 'invoice_items',
        description   : 'invoices',
        language_label: 'GROUP_RIGHT_TYPES.INVOICES',
        name          : 'invoices',
        parent        : 'vehicles',
        status        : false
      },
      {
        child         : '',
        description   : 'invoice items',
        language_label: 'GROUP_RIGHT_TYPES.INVOICE_ITEMS',
        name          : 'invoice_items',
        parent        : 'invoices',
        status        : false
      }
    ];
  }

  killCompanySessions ( companyId : string ) : Promise<any> {
    return this.apiService.post(`/workshop_admin/kill_company_sessions/${ companyId }`, {});
  }

  search ( query : string ) : ng.IPromise<Array<any>> {
    return this.apiService.stream('/searches', [ query, 'companies' ]);
  }

  wsToWsImport ( company : any ) : Promise<void> {
    const modalRef = this.modalService.open( WsToWsImportComponent, {
      windowClass: 'lg-modal'
    });

    modalRef.componentInstance.company = company;

    return modalRef.result;
  }

  wsToWsTransfer ( company : any, targetCompany : any, tables : Array<string> ) : Promise<any> {
    const url = `/workshop_admin/ws_to_ws_transfer/${ company.id }/${ targetCompany.id }`;
    return this.apiService.post(url, tables, 'tables');
  }
}
